import {
  FDList,
  FDStack,
  FDTitleText,
} from '@facet-wealth/design';
import React from 'react';
import { MetaResourceRenderer } from 'Components/UI/Meta/MetaForm/Components/MetaResourceRenderer';
import NeverIncludeItem from 'Views/Page/Content/Modal/Layouts/PlannerGuideLayout/Layout/components/NeverIncludeItem';
import PropTypes from 'prop-types';
import fr from 'facet-rest';


const NeverIncludeItems = ({ title, items }) => {
  return (
    <FDStack direction={'column'} spacing={1}>
      <FDTitleText size={'lg'} value={title} />
      <FDList>
        {items.map(item => {
          return (
            <MetaResourceRenderer
              resource={item}
              layout={NeverIncludeItem}
            />
          );
        })}
      </FDList>
    </FDStack>
  );
};

NeverIncludeItems.defaultProps = {
  title: '',
};

NeverIncludeItems.propTypes = {
  title: PropTypes.string,
  items: PropTypes.arrayOf(fr.Resource).isRequired,
};

export default NeverIncludeItems;
